export const STAKEHOLDER_LANES = [
  {
    id: "prospects",
    title: "Prospects",
    promise: "Name the weight, stop carrying it alone, and find your way back to peace at home.",
    charter:
      "Christian dads with children at home who are stretched thin, hurting, and near a tipping point.",
    status: "needs-action",
    widthClass: "min-w-[21rem] max-w-[21rem]",
  },
  {
    id: "dad-partners",
    title: "Dad Partners",
    promise: "Choose courage, receive brotherhood.",
    charter:
      "Men inside Dad Partners moving from burdened autopilot toward honesty, peace, and healthier family patterns.",
    status: "watch",
    widthClass: "min-w-[21rem] max-w-[21rem]",
  },
  {
    id: "guide-partners",
    title: "Guide Partners",
    promise: "Choose engagement, receive renewal.",
    charter:
      "Mature men and women whose story, grief, steadiness, and hope help dads feel seen and supported.",
    status: "watch",
    widthClass: "min-w-[21rem] max-w-[21rem]",
  },
  {
    id: "advisory-partners",
    title: "Advisory",
    promise: "Choose connection, receive fulfillment.",
    charter:
      "Pattern-seeing partners who stay grounded in live Dad Partners reality and help strengthen the mission.",
    status: "watch",
    widthClass: "min-w-[18rem] max-w-[18rem]",
  },
  {
    id: "support-partners",
    title: "Support",
    promise: "Choose support, receive human dividends.",
    charter:
      "People whose generosity funds visible change and who need trust, clarity, and real impact communication.",
    status: "healthy",
    widthClass: "min-w-[18rem] max-w-[18rem]",
  },
  {
    id: "super-fans",
    title: "Super Fans",
    promise: "Choose to amplify, receive joyful partnership.",
    charter:
      "People who have seen enough fruit that they cannot help sharing the mission with others.",
    status: "watch",
    widthClass: "min-w-[18rem] max-w-[18rem]",
  },
  {
    id: "operations",
    title: "Operations",
    promise: "Choose clear, comprehensive organization and planning, receive peace of mind.",
    charter:
      "The business, systems, planning, reporting, and trust lane that keeps the mission sustainable and answerable.",
    status: "needs-action",
    widthClass: "min-w-[19rem] max-w-[19rem]",
  },
];

export const STAKEHOLDER_LANE_APPEARANCE = {
  prospects: {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(217,119,6,0.16),_transparent_24%),linear-gradient(180deg,#fcfbf7_0%,#f5eee2_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(217,119,6,0.12),_transparent_24%),linear-gradient(180deg,#05080d_0%,#14100a_100%)]",
    shellClass:
      "border-amber-200/80 bg-amber-50/75 dark:border-amber-400/20 dark:bg-amber-500/[0.06]",
    panelClass:
      "border-amber-200/80 bg-amber-50/70 dark:border-amber-400/20 dark:bg-amber-500/[0.05]",
    statClass:
      "border-amber-200/80 bg-amber-50/85 dark:border-amber-400/20 dark:bg-amber-500/[0.08]",
    headingTextClass: "text-amber-800 dark:text-amber-200",
    titleHoverClass: "group-hover:text-amber-700 dark:group-hover:text-amber-200",
    iconHoverClass: "group-hover:text-amber-700 dark:group-hover:text-amber-200",
    cardHoverClass: "hover:border-amber-300 dark:hover:border-amber-400/30",
    flagClass: "border-amber-200 bg-amber-100 text-amber-900 dark:border-amber-400/25 dark:bg-amber-500/[0.14] dark:text-amber-100",
    chipClass: "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-400/20 dark:bg-amber-500/[0.08] dark:text-amber-100",
    accentTextClass: "text-amber-700 dark:text-amber-200",
  },
  "dad-partners": {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(202,138,4,0.16),_transparent_24%),linear-gradient(180deg,#fcfbf6_0%,#f3ecd9_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(202,138,4,0.12),_transparent_24%),linear-gradient(180deg,#05080d_0%,#151107_100%)]",
    shellClass:
      "border-yellow-200/80 bg-yellow-50/70 dark:border-yellow-400/20 dark:bg-yellow-500/[0.06]",
    panelClass:
      "border-yellow-200/80 bg-yellow-50/65 dark:border-yellow-400/20 dark:bg-yellow-500/[0.05]",
    statClass:
      "border-yellow-200/80 bg-yellow-50/85 dark:border-yellow-400/20 dark:bg-yellow-500/[0.08]",
    headingTextClass: "text-yellow-800 dark:text-yellow-200",
    titleHoverClass: "group-hover:text-yellow-700 dark:group-hover:text-yellow-200",
    iconHoverClass: "group-hover:text-yellow-700 dark:group-hover:text-yellow-200",
    cardHoverClass: "hover:border-yellow-300 dark:hover:border-yellow-400/30",
    flagClass: "border-yellow-200 bg-yellow-100 text-yellow-900 dark:border-yellow-400/25 dark:bg-yellow-500/[0.14] dark:text-yellow-100",
    chipClass: "border-yellow-200 bg-yellow-50 text-yellow-900 dark:border-yellow-400/20 dark:bg-yellow-500/[0.08] dark:text-yellow-100",
    accentTextClass: "text-yellow-700 dark:text-yellow-200",
  },
  "guide-partners": {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(13,148,136,0.15),_transparent_24%),linear-gradient(180deg,#f7fbfb_0%,#e7f3f1_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(13,148,136,0.11),_transparent_24%),linear-gradient(180deg,#05080d_0%,#081412_100%)]",
    shellClass:
      "border-teal-200/80 bg-teal-50/70 dark:border-teal-400/20 dark:bg-teal-500/[0.06]",
    panelClass:
      "border-teal-200/80 bg-teal-50/65 dark:border-teal-400/20 dark:bg-teal-500/[0.05]",
    statClass:
      "border-teal-200/80 bg-teal-50/85 dark:border-teal-400/20 dark:bg-teal-500/[0.08]",
    headingTextClass: "text-teal-800 dark:text-teal-200",
    titleHoverClass: "group-hover:text-teal-700 dark:group-hover:text-teal-200",
    iconHoverClass: "group-hover:text-teal-700 dark:group-hover:text-teal-200",
    cardHoverClass: "hover:border-teal-300 dark:hover:border-teal-400/30",
    flagClass: "border-teal-200 bg-teal-100 text-teal-900 dark:border-teal-400/25 dark:bg-teal-500/[0.14] dark:text-teal-100",
    chipClass: "border-teal-200 bg-teal-50 text-teal-900 dark:border-teal-400/20 dark:bg-teal-500/[0.08] dark:text-teal-100",
    accentTextClass: "text-teal-700 dark:text-teal-200",
  },
  "advisory-partners": {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(101,163,13,0.14),_transparent_24%),linear-gradient(180deg,#fafcf8_0%,#edf3e6_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(101,163,13,0.1),_transparent_24%),linear-gradient(180deg,#05080d_0%,#101408_100%)]",
    shellClass:
      "border-lime-200/80 bg-lime-50/70 dark:border-lime-400/20 dark:bg-lime-500/[0.06]",
    panelClass:
      "border-lime-200/80 bg-lime-50/65 dark:border-lime-400/20 dark:bg-lime-500/[0.05]",
    statClass:
      "border-lime-200/80 bg-lime-50/85 dark:border-lime-400/20 dark:bg-lime-500/[0.08]",
    headingTextClass: "text-lime-800 dark:text-lime-200",
    titleHoverClass: "group-hover:text-lime-700 dark:group-hover:text-lime-200",
    iconHoverClass: "group-hover:text-lime-700 dark:group-hover:text-lime-200",
    cardHoverClass: "hover:border-lime-300 dark:hover:border-lime-400/30",
    flagClass: "border-lime-200 bg-lime-100 text-lime-900 dark:border-lime-400/25 dark:bg-lime-500/[0.14] dark:text-lime-100",
    chipClass: "border-lime-200 bg-lime-50 text-lime-900 dark:border-lime-400/20 dark:bg-lime-500/[0.08] dark:text-lime-100",
    accentTextClass: "text-lime-700 dark:text-lime-200",
  },
  "support-partners": {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(190,24,93,0.12),_transparent_24%),linear-gradient(180deg,#fcfafb_0%,#f5e9ef_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(190,24,93,0.1),_transparent_24%),linear-gradient(180deg,#05080d_0%,#150a11_100%)]",
    shellClass:
      "border-pink-200/80 bg-pink-50/70 dark:border-pink-400/20 dark:bg-pink-500/[0.06]",
    panelClass:
      "border-pink-200/80 bg-pink-50/65 dark:border-pink-400/20 dark:bg-pink-500/[0.05]",
    statClass:
      "border-pink-200/80 bg-pink-50/85 dark:border-pink-400/20 dark:bg-pink-500/[0.08]",
    headingTextClass: "text-pink-800 dark:text-pink-200",
    titleHoverClass: "group-hover:text-pink-700 dark:group-hover:text-pink-200",
    iconHoverClass: "group-hover:text-pink-700 dark:group-hover:text-pink-200",
    cardHoverClass: "hover:border-pink-300 dark:hover:border-pink-400/30",
    flagClass: "border-pink-200 bg-pink-100 text-pink-900 dark:border-pink-400/25 dark:bg-pink-500/[0.14] dark:text-pink-100",
    chipClass: "border-pink-200 bg-pink-50 text-pink-900 dark:border-pink-400/20 dark:bg-pink-500/[0.08] dark:text-pink-100",
    accentTextClass: "text-pink-700 dark:text-pink-200",
  },
  "super-fans": {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(147,51,234,0.12),_transparent_24%),linear-gradient(180deg,#fbf9fc_0%,#efe7f6_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(147,51,234,0.1),_transparent_24%),linear-gradient(180deg,#05080d_0%,#120a15_100%)]",
    shellClass:
      "border-violet-200/80 bg-violet-50/70 dark:border-violet-400/20 dark:bg-violet-500/[0.06]",
    panelClass:
      "border-violet-200/80 bg-violet-50/65 dark:border-violet-400/20 dark:bg-violet-500/[0.05]",
    statClass:
      "border-violet-200/80 bg-violet-50/85 dark:border-violet-400/20 dark:bg-violet-500/[0.08]",
    headingTextClass: "text-violet-800 dark:text-violet-200",
    titleHoverClass: "group-hover:text-violet-700 dark:group-hover:text-violet-200",
    iconHoverClass: "group-hover:text-violet-700 dark:group-hover:text-violet-200",
    cardHoverClass: "hover:border-violet-300 dark:hover:border-violet-400/30",
    flagClass: "border-violet-200 bg-violet-100 text-violet-900 dark:border-violet-400/25 dark:bg-violet-500/[0.14] dark:text-violet-100",
    chipClass: "border-violet-200 bg-violet-50 text-violet-900 dark:border-violet-400/20 dark:bg-violet-500/[0.08] dark:text-violet-100",
    accentTextClass: "text-violet-700 dark:text-violet-200",
  },
  operations: {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(59,130,246,0.14),_transparent_24%),linear-gradient(180deg,#f8fbff_0%,#e8eef7_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(59,130,246,0.11),_transparent_24%),linear-gradient(180deg,#05080d_0%,#09111a_100%)]",
    shellClass:
      "border-sky-200/80 bg-sky-50/70 dark:border-sky-400/20 dark:bg-sky-500/[0.06]",
    panelClass:
      "border-sky-200/80 bg-sky-50/65 dark:border-sky-400/20 dark:bg-sky-500/[0.05]",
    statClass:
      "border-sky-200/80 bg-sky-50/85 dark:border-sky-400/20 dark:bg-sky-500/[0.08]",
    headingTextClass: "text-sky-800 dark:text-sky-200",
    titleHoverClass: "group-hover:text-sky-700 dark:group-hover:text-sky-200",
    iconHoverClass: "group-hover:text-sky-700 dark:group-hover:text-sky-200",
    cardHoverClass: "hover:border-sky-300 dark:hover:border-sky-400/30",
    flagClass: "border-sky-200 bg-sky-100 text-sky-900 dark:border-sky-400/25 dark:bg-sky-500/[0.14] dark:text-sky-100",
    chipClass: "border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-400/20 dark:bg-sky-500/[0.08] dark:text-sky-100",
    accentTextClass: "text-sky-700 dark:text-sky-200",
  },
};

export const getStakeholderLaneAppearance = (laneId) =>
  STAKEHOLDER_LANE_APPEARANCE[laneId] || {
    pageClass:
      "bg-[radial-gradient(circle_at_top_left,_rgba(34,211,238,0.12),_transparent_24%),linear-gradient(180deg,#f8fafc_0%,#eef2f7_100%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(34,211,238,0.09),_transparent_24%),linear-gradient(180deg,#05080d_0%,#0a1118_100%)]",
    shellClass:
      "border-slate-200/80 bg-[#f8fafc] dark:border-white/10 dark:bg-[#0b1118]",
    panelClass:
      "border-slate-200/80 bg-slate-50/85 dark:border-white/10 dark:bg-white/[0.03]",
    statClass:
      "border-slate-200/80 bg-slate-50/90 dark:border-white/10 dark:bg-white/[0.04]",
    headingTextClass: "text-cyan-700 dark:text-aqua",
    titleHoverClass: "group-hover:text-cyan-700 dark:group-hover:text-aqua",
    iconHoverClass: "group-hover:text-cyan-700 dark:group-hover:text-aqua",
    cardHoverClass: "hover:border-cyan-300 dark:hover:border-aqua/30",
    flagClass: "border-cyan-200 bg-cyan-50 text-cyan-800 dark:border-aqua/30 dark:bg-aqua/10 dark:text-aqua",
    chipClass: "border-cyan-200 bg-cyan-50 text-cyan-800 dark:border-aqua/20 dark:bg-aqua/[0.08] dark:text-aqua",
    accentTextClass: "text-cyan-700 dark:text-aqua",
  };

export const BUCKET_ORDER = ["needs-now", "moving", "watch"];

export const BUCKET_META = {
  "needs-now": {
    label: "Needs Now",
    empty: "Nothing urgent is surfaced here right now.",
  },
  moving: {
    label: "Moving",
    empty: "No clear movement is being reinforced yet.",
  },
  watch: {
    label: "Watch",
    empty: "No visible drift signals are being tracked yet.",
  },
};

export const LANE_STATUS_META = {
  healthy: {
    label: "Healthy",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-400/30 dark:bg-emerald-500/10 dark:text-emerald-200",
  },
  watch: {
    label: "Watch",
    className:
      "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-400/30 dark:bg-amber-500/10 dark:text-amber-100",
  },
  "needs-action": {
    label: "Needs action",
    className:
      "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-400/30 dark:bg-rose-500/10 dark:text-rose-100",
  },
};

export const BUCKET_META_STYLES = {
  "needs-now": {
    headingClass: "text-rose-700 dark:text-rose-200",
    borderClass: "border-rose-200/80 dark:border-rose-400/20",
  },
  moving: {
    headingClass: "text-emerald-700 dark:text-emerald-200",
    borderClass: "border-emerald-200/80 dark:border-emerald-400/20",
  },
  watch: {
    headingClass: "text-amber-700 dark:text-amber-100",
    borderClass: "border-amber-200/80 dark:border-amber-400/20",
  },
};
